// Use a Toast Library

import { notify } from 'components/common/toast';
import type { ToastPayload } from 'interface/common';

export function success({ title, message, className }: ToastPayload): void {
  notify({ type: 'success', data: { title, message }, className });
}

export function error({ title, message, className }: ToastPayload): void {
  notify({ type: 'danger', data: { title, message }, className });
}

export function warning({ title, message, className }: ToastPayload): void {
  notify({ type: 'warning', data: { title, message }, className });
}
